// cpf-state.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface CpfInformState {
  recipient: any;
  applicant: any;
  recipientId: number;
  applicantId: number;
  recipientName: string;
  applicantName: string;
  recipientlist: any[];
  documentList: any[];
  countRecipientDocuments: number;
  countApplicantDocuments: number;
  isRecipientAddressOutdated: boolean;
  isApplicantAddressOutdated: boolean;
  recipientCpf: string;
  applicantCpf: string;
  currentPerson: 'recipient' | 'applicant';
  timestamp: number;
}

@Injectable({
  providedIn: 'root'
})
export class CpfStateService {
  private readonly STORAGE_KEY = 'cpf_inform_state';
  
  private stateSource = new BehaviorSubject<CpfInformState | null>(null);
  public state$ = this.stateSource.asObservable();

  constructor() {
    // Carregar estado salvo ao inicializar
    this.loadState();
  }

  setState(state: CpfInformState): void {
    this.stateSource.next(state);
    this.saveStateToStorage(state);
  }

  getState(): CpfInformState | null {
    return this.stateSource.value;
  }

  clearState(): void {
    this.stateSource.next(null);
    this.clearStateFromStorage();
  }

  private saveStateToStorage(state: CpfInformState): void {
    try {
      const stateWithTimestamp = {
        ...state,
        timestamp: new Date().getTime()
      };
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(stateWithTimestamp));
    } catch (error) {
      console.warn('Não foi possível salvar estado no storage:', error);
    }
  }

  private loadState(): void {
    try {
      const savedState = sessionStorage.getItem(this.STORAGE_KEY);
      if (savedState) {
        const parsedState = JSON.parse(savedState);
        // Verificar se o estado não é muito antigo (opcional - 1 hora)
        const oneHour = 60 * 60 * 1000;
        if (new Date().getTime() - parsedState.timestamp < oneHour) {
          this.stateSource.next(parsedState);
        } else {
          this.clearStateFromStorage();
        }
      }
    } catch (error) {
      console.warn('Não foi possível carregar estado do storage:', error);
      this.clearStateFromStorage();
    }
  }

  private clearStateFromStorage(): void {
    try {
      sessionStorage.removeItem(this.STORAGE_KEY);
    } catch (error) {
      console.warn('Não foi possível limpar estado do storage:', error);
    }
  }
}